import t from "./stateManager.js";
const a = new t();
export {
  a as TokenManager,
  a as default
};
//# sourceMappingURL=tokenManager.js.map
